
/**
 * CollectionManager (Full jQuery Version)
 * Shopify AJAX Collection (no URL changes)
 * Author: Martynas
 */

class CollectionManager {
  constructor() {
    this.selectors = {
      wrapper: '#collection-products-wrapper',
      grid: '#collection-products',
      categoryLink: '.category-link',
      paginationLink: '.pagination-link',
      dropdownBtn: '#dropdownBtn',
      dropdownMenu: '#dropdownMenu',
      dropdownLabel: '#dropdownLabel',
      sortButtons: '#sort-menu button[data-sort]',
      filterForm: '#filterForm',
      clearBtn: '#clearFilters'
    };

    this.sortMap = {
      'manual': 'Bestsellers',
      'created-descending': 'Newest',
      'created-ascending': 'Oldest',
      'price-ascending': 'Price: Low to High',
      'price-descending': 'Price: High to Low',
      'title-ascending': 'A–Z',
      'title-descending': 'Z–A'
    };


    this.defaultSort = 'manual';
    this.currentSort = localStorage.getItem('currentSort') || this.defaultSort;

    this.init();
  }

  // -------------------- INIT -------------------- //
  init() {
    this.bindGlobalEvents();
    this.bindDropdownEvents();
    this.restoreSortState();
  }

  // -------------------- GLOBAL EVENTS -------------------- //
  bindGlobalEvents() {
    const self = this;

    // Category switching
    $(document).on('click', this.selectors.categoryLink, function (e) {
      e.preventDefault();
      let handle = $(this).data('collection-handle');
      if (!handle) return;
      let activeHandle = $(self.selectors.wrapper).data('collection-handle');

      if(activeHandle == handle)  {
        self.setCollectionToDefault();
        handle = $(self.selectors.wrapper).data('collection-handle');
      }
    
      const url = `/collections/${handle}?sort_by=${self.currentSort}`;
      self.fetchCollection(url);
    });

    // Pagination
    $(document).on('click', this.selectors.paginationLink, function (e) {
      e.preventDefault();
      const url = $(this).attr('href');
      if (!url) return;
      self.fetchCollection(url);
    });
  }

  // -------------------- DROPDOWN -------------------- //
  bindDropdownEvents() {
    const self = this;
    const $dropdownBtn = $(this.selectors.dropdownBtn);
    const $dropdownMenu = $(this.selectors.dropdownMenu);
    const $dropdownLabel = $(this.selectors.dropdownLabel);

    if (!$dropdownBtn.length || !$dropdownMenu.length) return;

    // Toggle dropdown
    $(document)
      .off('click.dropdownToggle')
      .on('click.dropdownToggle', this.selectors.dropdownBtn, function (e) {
        e.stopPropagation();
        $dropdownMenu.toggleClass('hidden');
      });

    // Close dropdown on outside click
    $(document)
      .off('click.dropdownOutside')
      .on('click.dropdownOutside', function (e) {
        if (!$(e.target).closest($dropdownBtn).length && !$(e.target).closest($dropdownMenu).length) {
          $dropdownMenu.addClass('hidden');
        }
      });

    // Sort selection
    $(document)
      .off('click.sortSelect')
      .on('click.sortSelect', this.selectors.sortButtons, function (e) {
        e.preventDefault();
        e.stopPropagation();

        const sortValue = $(this).data('sort');
        const sortLabel = self.sortMap[sortValue] || 'A–Z';

        $dropdownLabel.text(sortLabel);
        $dropdownMenu.addClass('hidden');
        self.currentSort = sortValue;
        localStorage.setItem('currentSort', sortValue);

        const currentPath = window.location.pathname;
        let baseUrl = currentPath;
        const handle = $(self.selectors.wrapper).data('collection-handle');
        baseUrl = `/collections/${handle}`;
        
        const ajaxUrl = `${baseUrl}?sort_by=${sortValue}`;
        self.fetchCollection(ajaxUrl);
      });
  }

  // -------------------- AJAX FETCH -------------------- //
  fetchCollection(url) {
    const self = this;
    self.showLoadingPlaceholder();

    $.ajax({
      url: url,
      type: 'GET',
      dataType: 'html',
      success: function (data) {
        const $newDom = $('<div>').html(data);
        const $newWrapper = $newDom.find(self.selectors.wrapper);
        const activeHandle = new URL(url, window.location.origin).pathname.split('/').pop();

        if ($newWrapper.length) {
          setTimeout(() => {
            $(self.selectors.wrapper)
              .hide()
              .html($newWrapper.html())
              .fadeIn(250);

            self.updateActiveCategory(activeHandle);
            self.scrollToWrapper();
            self.bindDropdownEvents(); // rebind after DOM change
            self.restoreSortState();
          }, 200);
        }
      },
      error: function (xhr, status, error) {
        console.error('AJAX fetch error:', error);
      }
    });
  }

  // -------------------- HELPERS -------------------- //
  showLoadingPlaceholder() {
    const $existingProducts = $(`${this.selectors.grid} .product-card`);
    const productCount = $existingProducts.length || 8;
    const columns = this.getGridColumns();

    let html = `<div id="ajax-loading-placeholder" class="loading-placeholder" style="grid-template-columns: repeat(${columns}, 1fr)">`;
    for (let i = 0; i < productCount; i++) {
      html += `<div class="loading-item"></div>`;
    }
    html += `</div>`;
    $(this.selectors.wrapper).html(html);
  }

  getGridColumns() {
    const w = $(window).width();
    if (w >= 1024) return 4;
    if (w >= 768) return 3;
    return 2;
  }

  scrollToWrapper() {
    const offset = $(this.selectors.wrapper).offset()?.top || 0;
    $('html, body').animate({ scrollTop: offset - 80 }, 600);
  }

  updateActiveCategory(activeHandle) {
    $(this.selectors.wrapper).data('collection-handle', activeHandle);
    const defaultHandle = $(this.selectors.wrapper).data('default-collection-handle');
    $(this.selectors.categoryLink).each(function () {
      const $parent = $(this).closest('div');
      const handle = $(this).data('collection-handle');

      if(defaultHandle == activeHandle) {
        $parent.removeClass('selected');
        $parent.removeClass('opacity-60');
        return;
      }
     
      if (handle === activeHandle) {
        $parent.addClass('selected');
        $parent.removeClass('opacity-60');
      } else {
        $parent.removeClass('selected');
        $parent.addClass('opacity-60');
      }

      
    });
  }

  setCollectionToDefault() {
    const defaultHandle = $(this.selectors.wrapper).data('default-collection-handle');
    this.updateActiveCategory(defaultHandle, true);
  }

  restoreSortState() {
    const sortLabel = this.sortMap[this.currentSort] || 'A–Z';
    $(this.selectors.dropdownLabel).text(sortLabel);
    
    $('#sort-menu button')
      .removeClass('bg-gray-100 font-semibold')
      .filter(`[data-sort="${this.currentSort}"]`)
      .addClass('bg-gray-100 font-semibold');
  }
}

// -------------------- INITIALIZE Collection page js -------------------- //
jQuery(document).ready(function ($) {
  new CollectionManager();
});
